/** Used for Canadian zip-codes  */
export const isValidCharAtPosition = (char: string, index: number): boolean => {
  const upperChar = char.toUpperCase();

  switch (index) {
    case 0:
      return /^[A-Z]$/.test(upperChar);
    case 1:
      return /^[0-9]$/.test(char);
    case 2:
      return /^[A-Z]$/.test(upperChar);
    case 3:
      return /^[- ]$/.test(char);
    case 4:
      return /^[0-9]$/.test(upperChar);
    case 5:
      return /^[A-Z]$/.test(upperChar);
    case 6:
      return /^[0-9]$/.test(upperChar);
    default:
      return false;
  }
};
